export const MAX_IMAGE_SIZE = 1024 * 1024 * 5;
export const ALLOWED_IMAGE_EXTENSIONS = ['image/png', 'image/jpg', 'image/jpeg'];
